import { Injectable } from "@angular/core";
import { ApiService } from "../../core/services/api.service";
import { Observable } from "rxjs/Observable";
import { TranslateService } from "@ngx-translate/core";
import { SessionStateService } from "../../core/services/session-state.service";
import {
  Router,
  ActivatedRoute,
} from "../../../../node_modules/@angular/router";
import { Subject } from "rxjs/Subject";
import { HOUSE_SERVICE_PROVIDERS } from "../../entities/houses/houses.constants";

@Injectable()
export class GeneralService {
  langChange: Subject<string> = new Subject<string>();
  connChange: Subject<boolean> = new Subject<boolean>();

  constructor(
    private apiService: ApiService,
    private sessionStateService: SessionStateService,
    public translate: TranslateService
  ) {
    this.supportedLanguages();
  }

  getBoxConnectionStatus(): Observable<boolean> {
    const houseId = this.sessionStateService.getHouse().houseId;
    return this.apiService
      .get(`/equipment/houses/${houseId}/device`)
      .map((response) => {
        const smartDeviceTypes = ["wifi", "redybox"];

        for (const { type, connectionState } of response) {
          const exists = smartDeviceTypes.includes(type);

          if (exists === true && connectionState === false) {
            return false;
          }
        }

        return true;
      });
  }

  getCustomerSupportNumber(): string {
    // If there is no house or serviceProvider defined, fallback is PT number
    if (
      !this.sessionStateService.getHouse() ||
      !this.sessionStateService.getHouse().serviceProvider
    ) {
      return this.translate.instant("Customer Service Number Portugal");
    }

    switch (this.sessionStateService.getHouse().serviceProvider) {
      case HOUSE_SERVICE_PROVIDERS.PORTUGAL:
        return this.translate.instant("Customer Service Number Portugal");
      case HOUSE_SERVICE_PROVIDERS.SPAIN:
        return this.translate.instant("Customer Service Number Spain");
      case HOUSE_SERVICE_PROVIDERS.SPAIN_TOTAL:
        return this.translate.instant("Customer Service Number Total");
      default:
        return this.translate.instant("Customer Service Number Portugal");
    }
  }

  supportedLanguages() {
    this.translate.addLangs(["en", "pt", "es"]);
  }

  initConnChange(): void {
    if (this.connChange) {
      this.connChange.unsubscribe();
      this.connChange = new Subject<boolean>();
    }
  }

  setDefaultLang() {
    this.translate.setDefaultLang("en");
  }

  usePortuguese() {
    this.translate.use("pt");
    this.langChange.next("pt");
  }

  useSpanish() {
    this.translate.use("es");
    this.langChange.next("es");
  }

  useEnglish() {
    this.translate.use("en");
    this.langChange.next("en");
  }

  useNavigatorLang() {
    if (navigator.language.startsWith("pt")) {
      this.translate.use("pt");
      this.langChange.next("pt");
    } else if (navigator.language.startsWith("es")) {
      this.translate.use("es");
      this.langChange.next("es");
    } else {
      this.translate.use("en");
      this.langChange.next("en");
    }
  }

  downloadPDF(url: string): any {
    return this.apiService.get(url).map((res) => {
      return new Blob([res], { type: "application/pdf" });
    });
  }

  isMobile() {
    return window.screen.width <= 480;
  }

  isWindowsPhone() {
    const userAgent = navigator.userAgent || navigator.vendor;
    return /windows phone/i.test(userAgent);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/general.service.ts